import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class BaseCell extends React.Component {

  constructor(props) {
    super(props);

  }

  messageClass(isBot) {
    return classNames(
      'cu-ui-message',
      {
        'cu-ui-message-bot': isBot,
        'cu-ui-message-user': !isBot
      }
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/chat-body/chat-cells/base-cell/index.jsx